import React, { Fragment, useEffect, useState } from "react"
import { Input, Table } from "reactstrap"
import PageBody from "../../../components/PageBody"
import NumberFormat from "react-number-format"
import TextUtils from "../../../helpers/TextUtils"
import profilePic from '../../../assets/images/users/no-img.jpg'
import iconSub from '../../../assets/images/icon-sub.png'


const ProductVarriant = (props: any) => {
    const { id, data, varriant, onlyView, type, imgs, unit, handleChangeVariant, attributes, stock, branch, getBranchItem, validation, onValidation} = props
    const warehouse_stock = stock?.reduce((prev: any, item: any) => {
        const branchItem = branch?.filter((b:any)=> b.id === item?.branch_id)
        if(branchItem && branchItem[0]) prev = [...prev, branchItem && branchItem[0]]
        return prev
    }, [])

    const attributeCount = attributes?.reduce((prev:any, item:any)=>{
        if(item?.properties?.length > 0) prev = prev + 1
        return prev
    },0)

    const unitCount = unit?.reduce((prev:any, item:any)=>{
        if(item?.name && item?.quantity_conversion) prev = prev + 1
        return prev
    },0) 

    const totalVarriant = attributeCount === 0 ? unitCount : (varriant?.length === 1 && unitCount == 1) ? 2 : (varriant?.length * (unitCount + 1))
    if(varriant?.length === 0) return null

    // console.log("varriant", varriant)
    return (
        <PageBody>
            <div className="nutri-title mb-3">Phiên bản ({totalVarriant})</div>
            <div>
                <Table className="mb-0 table-custom" responsive>
                    <RenderHeadData {...props} warehouse_stock={warehouse_stock}/>
                    <RenderBobyData {...props} warehouse_stock={warehouse_stock}/>
                </Table>
            </div>
        </PageBody>
    )
}

const RenderHeadData = (props:any) => {
    const { id, warehouse_stock} = props
    return (
        <thead>
            <tr>
                <th className="text-center" rowSpan={2} style={{ minWidth: 60}}>Tên phiên bản</th>
                <th className="text-center" rowSpan={2} style={{ minWidth: 60 }}>Mã SKU</th>
                <th className="text-center" rowSpan={2} style={{ minWidth: 120 }}>Mã vạch</th>
                <th className="text-center" rowSpan={2} style={{ minWidth: 120 }}>Giá bán lẻ</th>
                <th className="text-center" rowSpan={2} style={{ minWidth: 120 }}>Giá bán buôn</th>
                <th className="text-center" rowSpan={2} style={{ minWidth: 160 }}>Giá nhập</th>
                <th className="text-center" rowSpan={2} style={{ minWidth: 120 }}>VAT</th>
                <th className="text-center" rowSpan={2} style={{ minWidth: 120 }}>Khối lượng</th>
                {id === 'add' && warehouse_stock?.map((branch:any, index:number)=>{
                    return <th className="text-center" colSpan={2} key={`branch-title-${index}`} style={{ minWidth: 120 }}>{branch?.name}</th>
                })}
            </tr>
            {id === 'add' && 
            <tr>
                {warehouse_stock?.map((branch:any, index:number)=>{
                    return <Fragment key={`branch-title-sub-${index}`}>
                        <th className="text-center" style={{ minWidth: 120 }}>Tồn ban đầu</th>
                        <th className="text-center" style={{ minWidth: 120 }}>Giá vốn</th>
                    </Fragment>
                })}
            </tr>}
        </thead>
    )
}

const RenderBobyData = (props:any) => {
    const {id, warehouse_stock,varriant, data, onlyView, type, imgs, unit, handleChangeVariant, attributes, stock, branch, getBranchItem, onValidation, validation} = props
    
    return (
        <tbody>
            {varriant && varriant?.length > 0 && varriant?.map((item: any, index: number) => (
                <RenderItem 
                    key={`item-variant-${item?.sku}`}
                    dataItem={item} 
                    data={data}
                    id={id}
                    imgs={imgs} 
                    type={type}
                    index={index} 
                    warehouse_stock={warehouse_stock}
                    onlyView={onlyView}
                    getBranchItem={getBranchItem}
                    onValidation={onValidation}
                    handleChangeVariant={handleChangeVariant}
                    validation={validation && validation.varriant && validation.varriant[index]} 
                />
            ))}
        </tbody>
    )
}

const RenderItem = (props:any)=>{
    const {id, imgs, data, dataItem, index, indexParent = null, validation, handleChangeVariant, onlyView, type, warehouse_stock, getBranchItem, onValidation}  = props
    const [item, setItem] = useState<any>(dataItem);
    const handleChange = (name: string, value: any)=>{
        const newItem = {
            ...item,
            [name]: value
        }
        setItem(newItem)
        handleChangeVariant && handleChangeVariant(index, name, value, indexParent)
        const stockValidation = {
            ...validation?.varriant
        }
        if(!stockValidation[index]) stockValidation[index] = {}
        stockValidation[index].price = ''
        if(newItem?.price?.length === 0) stockValidation[index].price = 'Giá trị không được để trống!'
        newItem?.warehouse?.map((itemWarehouse:any, indexWarehouse:number)=>{
            if(
                (itemWarehouse?.quantity && !itemWarehouse?.price_cost)
                || (itemWarehouse?.price_cost && !itemWarehouse?.quantity)
            ){
                if(!stockValidation[index].branch) stockValidation[index].branch = {}
                if(!stockValidation[index].branch[itemWarehouse?.branch_id]) stockValidation[index].branch[itemWarehouse?.branch_id] = {}
                stockValidation[index].branch[itemWarehouse?.branch_id].price_cost
                = stockValidation[index].branch[itemWarehouse?.branch_id].quantity = ''
                if(itemWarehouse?.quantity && !itemWarehouse?.price_cost) stockValidation[index].branch[itemWarehouse?.branch_id].price_cost = 'Giá vốn không được để trống!'
                if(itemWarehouse?.price_cost && !itemWarehouse?.quantity) stockValidation[index].branch[itemWarehouse?.branch_id].quantity = 'Tồn đầu không được để trống!'
            }
        })
        onValidation({
            ...validation,
            varriant: stockValidation
        })
    }

    const handleChangeStock = (branch_id:number,  name: string, value: any)=>{
        const warehouseIndex = item?.warehouse?.findIndex((p:any) => p.branch_id == branch_id);
        const warehouseData:any = item?.warehouse || []
        if(warehouseData[warehouseIndex]){
            warehouseData[warehouseIndex][name] = value
        }
        handleChange("warehouse", warehouseData)
    }
    
    return (
        <>
        <tr key={`item-variant-${item?.sku}`}>
            <td>
                <div style={{
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    {indexParent !== null &&
                        <img  src={iconSub} style={{width: 20, height: 20, maxWidth: 'unset', maxHeight: 'unset', border: 'none', margin: 10}}/>
                    }
                    <label className="tee-file-preview" htmlFor="avatar" style={{width: 45, height: 45, marginRight: 10}}>
                        <img  src={data?.avatar || imgs && imgs[0]?.url || profilePic} style={{maxWidth: 'unset', maxHeight: 'unset'}}/>
                    </label>
                    <span style={{flex:1}}>{item?.name}</span>
                </div>
            </td>
            {/* <td>{item?.sku}</td> */}
            <td>
                <Input disabled={onlyView} type="text" value={type === 'view' && !item?.sku_alias ? '---': item?.sku_alias}  onChange={(e: any) => handleChange('sku_alias', e.target.value)} name="sku_alias" placeholder="Nhập mã SKU..." />
            </td>
            <td>
                <Input disabled={onlyView} type="text" value={type === 'view' && !item?.barcode ? '---': item?.barcode}  onChange={(e: any) => handleChange('barcode', e.target.value)} name="barcode" placeholder="Nhập mã barcode..." />
            </td>
            <td>
                <NumberFormat 
                    disabled={onlyView}
                    onChange={(e: any) => handleChange('price', TextUtils.onlyNumber(e.target.value))}
                    name={'price'} type={'text'} className="form-control" 
                    value={type === 'view' && !item?.price ? '---': item?.price}
                    placeholder={(type=='view' && !item?.price) ? "---" : "Nhập giá trị..."} thousandSeparator={true} 
                />
                {validation?.price &&<div className="invalid-feedback d-block" >{validation?.price}</div>}
            </td>
            
            <td>
                <NumberFormat 
                    disabled={onlyView}
                    onChange={(e: any) => handleChange('price_wholesale', TextUtils.onlyNumber(e.target.value))}
                    name={'price_wholesale'} type={'text'} className="form-control" 
                    value={type === 'view' && !item?.price_wholesale ? '---': item?.price_wholesale}
                    placeholder={(type=='view' && !item?.price_wholesale) ? "---" : "Nhập giá trị..."} thousandSeparator={true} 
                />
            </td>
            <td>
                <NumberFormat 
                    disabled={onlyView}
                    onChange={(e: any) => handleChange('price_import', TextUtils.onlyNumber(e.target.value))}
                    name={'price_import'} type={'text'} className="form-control" 
                    value={type === 'view' && !item?.price_import ? '---': item?.price_import}
                    placeholder={(type=='view' && !item?.price_import) ? "---" : "Nhập giá trị..."} thousandSeparator={true} 
                />
            </td>
            <td>
                <NumberFormat 
                    disabled={onlyView}
                    onChange={(e: any) => handleChange('vat', TextUtils.onlyNumber(e.target.value))}
                    name={'vat'} type={'text'} className="form-control" 
                    value={type === 'view' && !item?.vat ? '---': item?.vat}
                    placeholder={(type=='view' && !item?.vat) ? "---" : "Nhập giá trị..."} thousandSeparator={true} 
                />
            </td>
            <td>
                <NumberFormat 
                    disabled={onlyView}
                    onChange={(e: any) => handleChange('weight', TextUtils.onlyNumber(e.target.value))}
                    name={'weight'} type={'text'} className="form-control" 
                    value={type === 'view' && !item?.weight ? '---': item?.weight}
                    placeholder={(type=='view' && !item?.weight) ? "---" : "Nhập giá trị..."} thousandSeparator={true} 
                />
            </td>
            {id === 'add' && warehouse_stock?.map((itemBranch:any, indexBranch:number)=>{
                if(indexParent !== null) return <td colSpan={2}></td> 
                const itemWarehouseData = getBranchItem(itemBranch?.id, item?.warehouse)
                const validationBranch = validation && validation.branch && validation.branch[itemBranch?.id]
                return <Fragment key={`branch-body-${index}-${indexBranch}`}>
                    <td>
                        <NumberFormat 
                            disabled={onlyView}
                            onChange={(e: any) => handleChangeStock(itemBranch?.id,'quantity', TextUtils.onlyNumber(e.target.value))}
                            name={'quantity'} type={'text'} className="form-control" 
                            value={type === 'view' && !itemWarehouseData?.quantity ? '---': itemWarehouseData?.quantity}
                            placeholder={(type=='view' && !itemWarehouseData?.quantity) ? "---" : "Nhập giá trị..."} thousandSeparator={true} 
                            maxLength={12}
                        />
                        {validationBranch?.quantity &&<div className="invalid-feedback d-block" >{validationBranch?.quantity}</div>}
                    </td>
                    <td>
                        <NumberFormat 
                            disabled={onlyView}
                            onChange={(e: any) => handleChangeStock(itemBranch?.id, 'price_cost', TextUtils.onlyNumber(e.target.value))}
                            name={'price_cost'} type={'text'} className="form-control" 
                            value={type === 'view' && !itemWarehouseData?.price_cost ? '---': itemWarehouseData?.price_cost}
                            placeholder={(type=='view' && !itemWarehouseData?.price_cost) ? "---" : "Nhập giá trị..."} thousandSeparator={true} 
                            maxLength={12}
                        />
                        {validationBranch?.price_cost &&<div className="invalid-feedback d-block" >{validationBranch?.price_cost}</div>}
                    </td>
                </Fragment>
            })}
        </tr>
        {item?.units?.map((itemUnit:any, indexUnit:number)=>{
            return <RenderItem 
            dataItem={itemUnit} 
            indexParent={index} 
            index={indexUnit} 
            data={data}
            imgs={imgs} 
            type={type}
            warehouse_stock={warehouse_stock}
            onlyView={onlyView}
            getBranchItem={getBranchItem}
            onValidation={onValidation}
            handleChangeVariant={handleChangeVariant}
            validation={validation && validation.varriant && validation.varriant[indexUnit]} 
            />
        })}
        </>
    )
}

export default ProductVarriant